var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEreaser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eraser-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.0302 22.6895H13.9902C13.5702 22.6895 13.2402 22.3495 13.2402 21.9395C13.2402 21.5295 13.5802 21.1895 13.9902 21.1895H21.0302C21.4502 21.1895 21.7802 21.5295 21.7802 21.9395C21.7802 22.3495 21.4502 22.6895 21.0302 22.6895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.64 17.3788C14.03 17.7688 14.03 18.3988 13.64 18.7988L10.66 21.7788C9.55 22.8888 7.77 22.9488 6.59 21.9588C6.52 21.8988 6.46 21.8388 6.4 21.7788L5.53 20.9088L3.74 19.1188L2.88 18.2588C2.81 18.1888 2.75 18.1188 2.69 18.0488C1.71 16.8688 1.78 15.1088 2.88 14.0088L5.86 11.0288C6.25 10.6388 6.88 10.6388 7.27 11.0288L13.64 17.3788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.1194 11.3308L16.1194 16.3308C15.7294 16.7208 15.0994 16.7208 14.7094 16.3308L8.33937 9.98086C7.94938 9.59086 7.94938 8.96086 8.33937 8.56086L13.3394 3.57086C14.5094 2.40086 16.4294 2.40086 17.5994 3.57086L21.1194 7.08086C22.2894 8.25086 22.2894 10.1609 21.1194 11.3308Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEreaser);
export default __webpack_public_path__ + "static/media/ereaser.835e31a03f86f1a3663faeb1d731acdc.svg";
export { ForwardRef as ReactComponent };